/**
 * Vue plugin to integrate Microsoft Clarity tracking
 */

import { identifyUser } from '@/utility/clarityTracking'

export default {
    install(app) {
        // Global method to track Clarity events
        app.config.globalProperties.$clarityTrack = function(event, data) {
            if (typeof window.clarity !== 'undefined') {
                window.clarity("event", event, data || {});
            }
        };
        
        // Global method to identify user
        app.config.globalProperties.$clarifyIdentify = function(user) {
            identifyUser(user);
        };
    }
}

